const DEFAULT_TITLE = "Secure Pay";

const DEFAULT_FAVICON = "/favicon.png";

//  Apply branding to browser
export const applyBranding = ({ title, favicon } = {}) => {
  // Browser title
  document.title = title || DEFAULT_TITLE;

  // Browser favicon
  let link = document.getElementById("dynamic-favicon");

  if (!link) {
    link = document.createElement("link");

    link.id = "dynamic-favicon";

    link.rel = "icon";

    document.head.appendChild(link);
  }

  link.href = (favicon || DEFAULT_FAVICON) + "?v=" + Date.now();
};

//  Save branding
export const saveBranding = ({ title, favicon }) => {
  const brandingData = {
    title: title || DEFAULT_TITLE,

    favicon: favicon || DEFAULT_FAVICON,
  };

  localStorage.setItem("branding", JSON.stringify(brandingData));

  return brandingData;
};

//  Load branding
export const loadBranding = () => {
  try {
    const cached = localStorage.getItem("branding");

    if (cached) {
      const brandingData = JSON.parse(cached);

      applyBranding(brandingData);

      return brandingData;
    }

    applyBranding({});

    return null;
  } catch (error) {
    applyBranding({});

    return null;
  }
};

//  Clear branding
export const clearBranding = () => {
  localStorage.removeItem("branding");

  applyBranding({});
};

// ----------------------- for OG Tag changes ------------------------

// const DEFAULT_TITLE = "Secure Pay";
// const DEFAULT_FAVICON = "/favicon.png";

// const updateMetaTag = (attr, key, value) => {
//   let tag = document.querySelector(`meta[${attr}="${key}"]`);

//   if (!tag) {
//     tag = document.createElement("meta");
//     tag.setAttribute(attr, key);
//     document.head.appendChild(tag);
//   }

//   tag.setAttribute("content", value);
// };

// export const applyBranding = ({ title, favicon } = {}) => {
//   const pageTitle = title || DEFAULT_TITLE;
//   const imageUrl = favicon || DEFAULT_FAVICON;

//   // Browser Title
//   document.title = pageTitle;

//   // Favicon
//   let faviconLink = document.getElementById("dynamic-favicon");

//   if (!faviconLink) {
//     faviconLink = document.createElement("link");
//     faviconLink.id = "dynamic-favicon";
//     faviconLink.rel = "icon";
//     document.head.appendChild(faviconLink);
//   }

//   faviconLink.href = imageUrl + "?v=" + Date.now();

//   // Open Graph
//   updateMetaTag("property", "og:title", pageTitle);
//   updateMetaTag("property", "og:description", pageTitle);
//   updateMetaTag("property", "og:image", imageUrl);
//   updateMetaTag("property", "og:url", window.location.href);
//   updateMetaTag("property", "og:type", "website");

//   // Twitter
//   updateMetaTag("name", "twitter:card", "summary_large_image");
//   updateMetaTag("name", "twitter:title", pageTitle);
//   updateMetaTag("name", "twitter:description", pageTitle);
//   updateMetaTag("name", "twitter:image", imageUrl);
// };

// export const saveBranding = ({ title, favicon }) => {
//   const brandingData = {
//     title: title || DEFAULT_TITLE,
//     favicon: favicon || DEFAULT_FAVICON,
//   };

//   localStorage.setItem("branding", JSON.stringify(brandingData));

//   applyBranding(brandingData);

//   return brandingData;
// };

// export const loadBranding = () => {
//   try {
//     const cached = localStorage.getItem("branding");

//     if (cached) {
//       const brandingData = JSON.parse(cached);

//       applyBranding(brandingData);

//       return brandingData;
//     }

//     applyBranding({});
//     return null;
//   } catch (error) {
//     applyBranding({});
//     return null;
//   }
// };

// export const clearBranding = () => {
//   localStorage.removeItem("branding");
//   applyBranding({});
// };
